
import { Enums } from '@bode-canada/core';
import { IconType } from '@/ui-kit/components/icon/enums';
import { StyleColorSchemeType } from '@/ui-kit/styles/enums';
import StyleClassNamesBuilder from '@/ui-kit/styles/helpers/StyleClassNamesBuilder';
import { formatDatetime, getDiff } from '@/utils/date';
import { formatMoney } from '@/utils/utilities';
import CommissionHelper from '@/utils/commission';

const HUNDRED = 100;
const NOT_AVAILABLE = 'N/A';

export default {
  name: 'SoldData',
  props: {
    listing: {
      default: () => {},
      type: Object,
    },
  },
  data: () => ({
    IconType,
    StyleColorSchemeType,
  }),
  computed: {
    soldDataItems() {
      const {
        price,
        listPrice,
        soldPrice,
        commissionSavings,
      } = this.listing;

      let items = [
        {
          title: 'Sold Date',
          value: this.soldDate,
        },
        {
          title: 'List Price',
          value: this.getPrice(listPrice || price),
        },
        {
          title: 'Sold Price',
          value: this.getPrice(soldPrice || price),
        },
        {
          title: 'Sold/List Ratio',
          value: this.soldRatio,
        },
      ];

      if (this.isBode) {
        items = [
          ...items,
          commissionSavings
            ? {
              title: 'Seller\'s Total Savings',
              value: this.getPrice(commissionSavings) || NOT_AVAILABLE,
            }
            : null,
          {
            title: 'Days on Market',
            value: this.daysOnMarket,
          },
        ];
      }

      return items.filter(Boolean);
    },
    soldDate() {
      return formatDatetime({
        datetime: this.listing.closed_at || this.listing.closedAt,
        format: 'MMMM D, YYYY',
      });
    },
    soldRatio() {
      const {
        price,
        listPrice,
        soldPrice,
      } = this.listing;
      const ratio = listPrice
        ? Math.round(((soldPrice || price) / listPrice) * HUNDRED)
        : HUNDRED;
      return `${ratio}%`;
    },
    totalSavings() {
      const { commissionSaved, price, province } = this.listing;
      return commissionSaved
        ? this.getPrice(commissionSaved)
        : CommissionHelper.getBuyerCommission(price, province);
    },
    daysOnMarket() {
      const {
        daysOnMarket,
        publishedAt,
      } = this.listing;
      if (!daysOnMarket && !publishedAt) return '-';
      let days = daysOnMarket;
      if (!days) {
        days = getDiff({ toDatetime: publishedAt, unit: 'day' });
      }
      return days;
    },
    isBode() {
      return this.listing.origin === Enums.ListingOriginEnum.BODE;
    },
    containerClassNames() {
      return new StyleClassNamesBuilder('sold-data-list')
        .addConditionClassName('bode', this.isBode)
        .build();
    },
  },
  methods: {
    getPrice(input) {
      return input ? formatMoney(input) : '';
    },
  },
};
